import React from "react";
import { Badge } from "./ui/badge";
import Reveal from "./Reveal";
import { paymentMethods } from "../mock";

const PaymentQRs = ({
  title = "Three ways to register & pay",
  subtitle = "Scan a code with your phone to pay securely via Zelle, Venmo, or Cash App.",
  className = "bg-secondary/40",
}) => (
  <section className={`py-16 ${className}`}>
    <div className="container-prc">
      <Reveal className="text-center max-w-2xl mx-auto mb-8">
        <Badge className="bg-white text-primary hover:bg-white rounded-full px-4 py-1.5 font-semibold mb-4">Ways to Give</Badge>
        <h2 className="font-display font-extrabold text-3xl text-foreground">{title}</h2>
        {subtitle && <p className="mt-3 text-muted-foreground">{subtitle}</p>}
      </Reveal>
      <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
        {paymentMethods.map((m, i) => (
          <Reveal key={m.name} delay={i * 90}>
            <div className="card-hover bg-white rounded-2xl p-6 shadow-soft text-center h-full flex flex-col items-center">
              <div className="rounded-xl overflow-hidden bg-white border border-border w-full max-w-[220px]">
                <img src={m.qr} alt={`${m.name} QR code — scan to give`} className="w-full block" />
              </div>
              <h3 className="font-display font-bold text-lg text-foreground mt-5">{m.name}</h3>
              <p className="text-sm text-muted-foreground mt-1">{m.note}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default PaymentQRs;
